import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'mobily-ui-library/lib';
import Modal from '../Modal/Modal';
import GameCardComponent from '../GameCard/GameCard';

import { gameData } from '../../data/GameData';
import ArrowLeft from '../../assets/ArrowLeft.svg';
import ArrowRight from '../../assets/ArrowRight.svg';
import './Home.scss';

const win: any = window;

type AppProps = {
    rtl: boolean
}

function Home({ rtl }: AppProps) {
    const { t } = useTranslation();
    const [modalFlag, setModalFlag] = useState(false);
    const [game, setGame] = useState({});

    const handleModalClick = (value: any) => {
        setGame(value)
        setModalFlag(true);
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }

    const onArrowClick = () => {
        win['location'] = '/wps/portal/web/personal/';
    }

    return (
        <div className={rtl ? 'container Home__Container HomeArabic' : 'container Home__Container'}>
            <div className='row'>
                <div className='Home' style={{ direction: rtl ? 'rtl' : 'ltr' }}>
                    <img src={rtl ? ArrowRight : ArrowLeft} alt='arrow' className='arrow' onClick={onArrowClick} />
                    <section className='header__section'>
                        <Typography rtl={rtl} className='game-title'>{t('game_title')}</Typography>
                    </section>
                    <section className='game__section'>
                        <GameCardComponent rtl={rtl} handleModalClick={handleModalClick} gameData={gameData} />
                    </section>
                </div>

                {modalFlag && <Modal rtl={rtl} handleCancel={setModalFlag} game={game} />}
            </div>
        </div>
    )
}

export default Home;